import React, { useState } from "react";
import { getUserRole } from "../utils/utils";
import Dropdown from "./Dropdown";
import { Button, Card, CardContent } from "@deere/fuel-react";
import { Autocomplete, Box, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "../common/translation-context";
import { useSelector } from "react-redux";
import {ROLES} from "../constants/constant";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const SearchBar = (props) => {
  const history = useHistory();
  const path = history.location.pathname;
  const userData = useSelector((state) => state.userState.userData);
  const [isDisabled, setIsDisabled] = useState(false);
  const { translate: t } = useTranslation();

  const handleClearButton = () => {
    if (props.onClear) {
      props.onClear();
    }
  };

  const handleCountryChange = (value) => {
    setIsDisabled(false);
    props.onCountryChange(value);
  };

  const handleExtensionTypeChange = (value) => {
    setIsDisabled(false);
    props.onExtensionChange(value);
  };

  const handleIbCountryChange = (value) => {
    props.handleIbCountryChange(value);
  };

  const handleIbMonthChange = (value) => {
    props.handleIbMonthChange(value);
  };

  const handleIbClear = () => {
    return window.location.reload(false);
  }; 

  const countryType = (
    <Dropdown
      label="Country"
      onDropdownChange={handleCountryChange}
      value={props.selectedCountry}
      options={props.countryOptions}
    />
  );

  const extensionType = (
    <Dropdown
      label="Extension Type"
      onDropdownChange={handleExtensionTypeChange}
      value={props.selectedExtension}
      options={props.extensionOptions}
    />
  );

  const financingReference = (
  <div style={{ display: "flex", flexDirection: "column", width: "21rem" }}>
    <label>Financing Reference</label>
    <Autocomplete
      options={props.referenceContractOptions || []}
      value={props.selectedReferenceContract || null}
      onChange={(_, newValue) =>
        props.onReferenceContractChange && props.onReferenceContractChange(newValue || "")
      }
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "2.25rem",
          padding: "0 0.5rem",
        },
        "& .MuiAutocomplete-input": {
          padding: "0 !important",
        },
        "& .MuiAutocomplete-input::placeholder": {
          color: "#666666",
          opacity: 1,
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search Financing Reference"
          size="small"
          variant="outlined"
        />
      )}
      popupIcon={<KeyboardArrowDownIcon />}
      isOptionEqualToValue={(option, value) => option === value}
    />
  </div>
);
const serialNumber = (
  <div style={{ display: "flex", flexDirection: "column", width: "21rem" }}>
    <label>Serial Number</label>
    <Autocomplete
      multiple
     // freeSolo
      filterSelectedOptions
      clearOnBlur={false}
      selectOnFocus
      handleHomeEndKeys
      options={props.serialNoOptions || []}
      value={props.selectedSerialNos || []}
      onChange={(_, newValue) =>
        props.onSerialNoChange && props.onSerialNoChange(newValue || [])
      }
      filterOptions={(options, params) => {
        const filtered = options.filter((option) =>
          option.toLowerCase().includes(params.inputValue.toLowerCase())
        );
        return filtered;
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          minHeight: "2.25rem",
          padding: "0.25rem 0.5rem",
        },
        "& .MuiAutocomplete-input": {
          padding: "0 !important",
        },
        "& .MuiAutocomplete-input::placeholder": {
          color: "#666666",
          opacity: 1,
        },
        "& .MuiChip-root": {
          height: "1.5rem",
          margin: "2px",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={props.selectedSerialNos?.length ? "" : "Search Serial Number"}
          size="small"
          variant="outlined"
        />
      )}
      popupIcon={<KeyboardArrowDownIcon />}
      isOptionEqualToValue={(option, value) => option === value}
    />
  </div>
);
const ibCountries = (
    <Dropdown
      label="Country"
      onDropdownChange={handleIbCountryChange}
      value={props.selectedCountry}
      options={props.countryList}
    />
  );

  const ibMonths = (
    <Dropdown
      label="Fiscal Month"
      onDropdownChange={handleIbMonthChange}
      value={props.selectedMonth}
      options={props.monthList}
    />
  );

  const extensionCondtion = path.includes("extension");
  const ibCondition = path.includes("interestBearing");

  return (
    <>
      <Box>
        <Card>
          <CardContent>
            <h3 style={{ marginBottom: "1%" }}>{t("filters")}</h3>
            <div className="action-area">
              {extensionCondtion &&
                getUserRole(userData) !== ROLES.CCM &&
                countryType}
              {extensionCondtion && props.view !== "logs" && extensionType}
{extensionCondtion && props.view !== "logs" && financingReference}
              {extensionCondtion && props.view !== "logs" && serialNumber}
              {ibCondition && ibCountries}
              {ibCondition && ibMonths}              
              {!ibCondition && (
                <Button
                  disabled={isDisabled}
                  variant="secondary"
                  onClick={ibCondition ? handleIbClear : handleClearButton}
                >
                  {t("clear")}
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default SearchBar;
